module.exports = __webpack_public_path__ + "static/media/logo-bigin.16980c49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-bigin.png
// module id = 1297
// module chunks = 17